/**
 * Order status constants and utilities for the application
 */

// Order status enum
export const ORDER_STATUS = {
  PAID: 'PAID',
  SELLER_SHIPPED: 'SELLER_SHIPPED',
  WAREHOUSE_RECEIVED: 'WAREHOUSE_RECEIVED',
  VERIFYING: 'VERIFYING',
  WAREHOUSE_SHIPPED: 'WAREHOUSE_SHIPPED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

// cancellation reason enum
export const CANCELLATION_REASON = {
  SELLER_TIMEOUT: 'SELLER_TIMEOUT',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
  ADMIN_CANCELLED: 'ADMIN_CANCELLED',
};

// Status to step mapping for the stepper component
export const getOrderStatusStepIndex = (status, isOfficial) => {
  const statusToStepMap = isOfficial ? {
    [ORDER_STATUS.PAID]: 0,
    [ORDER_STATUS.WAREHOUSE_SHIPPED]: 1,
    [ORDER_STATUS.COMPLETED]: 2
  } : {
    [ORDER_STATUS.PAID]: 0,
    [ORDER_STATUS.SELLER_SHIPPED]: 1,
    [ORDER_STATUS.WAREHOUSE_RECEIVED]: 2,
    [ORDER_STATUS.VERIFYING]: 3,
    [ORDER_STATUS.WAREHOUSE_SHIPPED]: 4,
    [ORDER_STATUS.COMPLETED]: 5
  };
  
  return statusToStepMap[status] || 0;
};

// Status to translation key mapping
export const getOrderStatusTranslationKey = (status, isOfficial) => {
  if (status != ORDER_STATUS.CANCELLED && isOfficial && getOrderStatusStepIndex(status, isOfficial) === 0) {
    return `orders.status.${ORDER_STATUS.PAID.toLowerCase()}`;
  } else {
    return `orders.status.${status.toLowerCase()}`;
  }
};

// Helper to get message title translation key
export const getOrderMessageTitleKey = (status, isOfficial) => {
  if (status != ORDER_STATUS.CANCELLED && isOfficial && getOrderStatusStepIndex(status, isOfficial) === 0) {
    return `orders.messageTitles.${ORDER_STATUS.PAID.toLowerCase()}`;
  } else {
    return `orders.messageTitles.${status.toLowerCase()}`;
  }
};

// Helper to get explanation translation key
export const getOrderExplanationKey = (status, isOfficial) => {
  if (status != ORDER_STATUS.CANCELLED && isOfficial && getOrderStatusStepIndex(status, isOfficial) === 0) {
    return `orders.explanations.${ORDER_STATUS.PAID.toLowerCase()}`;
  } else {
    return `orders.explanations.${status.toLowerCase()}`;
  }
};

// Helper to get explanation translation key
export const getCancellationReasonKey = (cancellationReason, verificationNote) => {
  switch (cancellationReason) {
    case CANCELLATION_REASON.SELLER_TIMEOUT:
    case CANCELLATION_REASON.ADMIN_CANCELLED:
      return `orders.explanations.cancelled.${cancellationReason.toLowerCase()}`;
    case CANCELLATION_REASON.VERIFICATION_FAILED:
      return verificationNote ? `orders.explanations.cancelled.${cancellationReason.toLowerCase()}` : 'orders.explanations.cancelled.default';
    default:
      return 'orders.explanations.cancelled.default';
  }
};

// Helper to check if an order status is cancelled
export const isOrderCancelled = (status) => {
  return status === ORDER_STATUS.CANCELLED;
};
